import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { newBaseUrl } from '../../Consts';

function ProtectedRoute({ children }) {
  const [checking, setChecking] = useState(true);
  const [valid, setValid] = useState(false);

  useEffect(() => {
    const checkToken = async () => {
      const token = localStorage.getItem('token');

      if (!token) {
        setValid(false);
        setChecking(false);
        return;
      }

      try {
        const response = await axios.get(`${newBaseUrl}/api/admin/partners`, {
          headers: { Authorization: `Bearer ${token}` },
          // ✅ هنا المفتاح السحري
          validateStatus: (status) => true,
        });

        if (response.status === 200) {
          setValid(true);
        } else if (response.status === 401) {
          console.warn('Token expired or invalid');
          localStorage.removeItem('token');
          setValid(false);
        } else {
          setValid(false);
        }
      } catch (err) {
        console.error('Unexpected error:', err);
        localStorage.removeItem('token');
        setValid(false);
      } finally {
        setChecking(false);
      }
    };

    checkToken();
  }, []);

  if (checking) return <div>Loading...</div>;

  return valid ? children : <Navigate to="/Login" replace />;
}

export default ProtectedRoute;
